// extracted by mini-css-extract-plugin
export default {"searchPopover":"SearchExpensePopover_searchPopover__MfOl-"};